import Axios from 'axios'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

import DataType from 'types/transformation/enums/DataType'

export type SIMSchemaField = {
  name: string
  real_name: string
  type: DataType

  // Field section from the model. 'customer_specific' and the like are carried
  // through so the consumer decides what to leave out.
  section?: string

  // 'required' | 'recommended' | 'optional' — how badly we need the field.
  requirement?: string

  // Fields we derive ourselves and never ask a customer to deliver.
  exclude_from_requirement?: boolean

  description?: string
}

export type SIMSchemaModel = {
  name: string
  technical_name: string
  plural: string

  // Domain the model belongs to; drives one sheet per category on export.
  category?: string

  description?: string

  // Models we never ask a customer to deliver.
  exclude_from_requirement?: boolean

  fields: SIMSchemaField[]
}

const homepal_mdm_api =
  process.env.REACT_APP_HOMEPAL_MDM_API_DEV || 'http://localhost:3990/'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? homepal_mdm_api
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v4/data-products`

export async function getSIM(type: 'custom' | 'standard' = 'standard') {
  return getWithRedirect(`${URL}?type=${type}`)
}

export async function getSIMSchema() {
  return getWithRedirect<SIMSchemaModel[]>(`${URL}/schema`)
}

export async function deleteCustomSIM() {
  return Axios.delete(`${URL}/custom`, parseAuthenticationHeader())
}
